import { showSuccessToast } from "../store/slices/successToastSlice"

/** Default toast when AI Planner generation finishes off-route. */
export const AI_PLANNER_READY_TOAST = {
  message: "Your AI-generated posts are ready.",
  subtext: "Review your updated content in AI Planner.",
  actionLabel: "Go to AI Planner",
  actionPath: "/ai-planner",
}

/** Shows global `SuccessToast` (top-left slide-in). Accepts a string or toast payload. */
export function showAppToast(dispatch, messageOrPayload) {
  if (!dispatch || messageOrPayload == null) return
  if (typeof messageOrPayload === "string") {
    const message = messageOrPayload.trim()
    if (!message) return
    dispatch(showSuccessToast({ message }))
    return
  }
  if (typeof messageOrPayload === "object") {
    dispatch(showSuccessToast(messageOrPayload))
  }
}
